<template>
  <div>
    <documents-item-vue v-for='document in documents' v-bind:key="document.id" />
  </div>
</template>

<script>

export default {
  props: ['filters'],
  data: function() {
    return {
      documents: [],
      page: 0,
      rows: 10,
      num_found: 0,
      loading: false
    }
  },
  components: {
    'documents-item-vue': () => import(/* webpackChunkName: "[request]" */ "components/documents/Item")
  },
  methods: {
    fetch_data: function() {
      if (!this.loading) {
        this.loading = true
        this.$http.get('documents', {params: {filters: this.filters, rows: this.rows, page: this.page}}).
        then(
          response => {
            if (response.data) {
              this.documents = this.documents.concat(response.data.result)
              this.num_found = response.data.total
              this.page++
            } else {
              alert('No se han podido recuperar documentos')
            }
            this.loading = false
          },
          error => {console.log(error)})
      }
    }
  },
  watch: {
    filters: function (new_filters, old_filters) {
      if(new_filters.length != old_filters.length) {
        this.documents = []
        this.page = 0
        this.fetch_data()
      }
    }
  },
  created() {
    this.fetch_data()
  }
}
</script>

<style scoped>

</style>
